"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrySegment = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let IndustrySegment = class IndustrySegment {
    constructor(id, name, createdBy, updatedBy, description) {
        this.id = id;
        this.name = name;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.description = description;
    }
};
exports.IndustrySegment = IndustrySegment;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], IndustrySegment.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], IndustrySegment.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], IndustrySegment.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], IndustrySegment.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], IndustrySegment.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], IndustrySegment.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], IndustrySegment.prototype, "updatedBy", void 0);
exports.IndustrySegment = IndustrySegment = tslib_1.__decorate([
    (0, typeorm_1.Entity)("industry_segment"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String])
], IndustrySegment);
